module.exports = __webpack_public_path__ + "img/ic_140_achievement_volltreffer.3feb8714.svg";